<template>
  <span>
    <div v-if="errorMessage">
      <base-alert type="danger">
          <span class="alert-inner--text"><strong>{{ errorMessage }}</strong></span>
      </base-alert>      
    </div>
  </span>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: null,
    };
  },
 mounted() {
      this.$bus.$on("network-error", () => {
      this.errorMessage = this.$t("network-error")
    });

    this.$bus.$on("network-ok", () => {
      this.errorMessage = null;
    });
  },
 beforeDestroy() {
    this.$bus.$off("network-error");
    this.$bus.$off("network-ok");
  },  
  computed: {
  },
  methods: {
    closeDialog() {
      this.$bus.$emit('close-news-dialog');
    }    
  }
};
</script>

<i18n>
{
  "en": {
    "network-error": "Network error. Please try to refresh this page."
  },
  "fi": {
    "network-error": "Ongelma verkkoyhteydessä. Yritä uudelleenladata tämä sivu."
  },
 "sv": {
    "network-error": "Nätverksfel. Försök att uppdatera den här sidan."
  },
 "de": {
    "network-error": "Netzwerkfehler. Bitte versuchen Sie, diese Seite zu aktualisieren."
  },
  "ko": {
    "network-error": "네트워크 오류. 이 페이지를 새로고침해 보세요."
  }
}
</i18n>
